export default "__VITE_ASSET__Zht5mBSH__"